import { pxToNumber } from "../../_utils/styles.js";
import { tokens } from "../../context/weet-tokens.js";
const buttonThemeConfig = {
    tokens: {
        contentFontSizeLG: 14,
        contentFontSizeSM: 13,
        contentFontSize: 14,
        paddingInline: pxToNumber(tokens.weetSpace200) - 1,
        paddingInlineLG: pxToNumber(tokens.weetSpace250) - 1,
        paddingInlineSM: pxToNumber(tokens.weetSpace150) - 1,
        defaultHoverBorderColor: tokens.weetColorBackgroundBrandDefaultHover,
        defaultHoverColor: tokens.weetColorBackgroundBrandDefaultHover,
        groupBorderColor: tokens.weetColorBackgroundBrandDefaultHover,
        defaultActiveColor: tokens.weetColorBackgroundBrandDefaultClick,
        defaultActiveBorderColor: tokens.weetColorBackgroundBrandDefaultClick,
        defaultShadow: '',
        dangerShadow: '',
        primaryShadow: '',
        onlyIconSize: 16
    },
    config: {}
};
export { buttonThemeConfig };
